import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {CONFIG} from "../../../app/config";
import {TAction, TCentralLido} from "../../../app/enum";
import {DomSanitizer} from "@angular/platform-browser";

import {ProfileService} from "../../../providers/profile-service";
import {ProfilePagePage} from "../profile-page/profile-page";
import {LogadoService} from '../../../providers/logado-service';
import {PushService} from '../../../providers/push-service';

@Component({
    selector: 'page-develop-menu',
    templateUrl: 'develop-menu.html',
    providers: [ProfileService, PushService]
})
export class DevelopMenuPage {

    TCentralLido: any = TCentralLido;

    config: any;

    etapa: number;

    logado: any;
    rootile: any;
    rootdev: any;
    notifyes: any;

    developID: number;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService,
                public pushService: PushService,
                public profileService: ProfileService, public sanitizer: DomSanitizer) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');
        this.developID = this.navParams.get('developID');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Voucher Info', '/voucher-info');

        if (this.etapa == 1) this.developLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        if (this.etapa == 0 && !this.notifyes) this.centralLoad();

    }

    centralLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.central(TAction.acList, '', this.rootile.Profile.ProfileID, 0, 0)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.centralRead(data),
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    centralRead(data) {
        this.notifyes = data.Notifyes;
        
        // Notifye Read - Select Lido
        let count = 0;
        let reader = "";
        let unreads = this.notifyes.filter(notifye => (notifye.NotifyePush != TCentralLido.clRead));
        unreads.forEach(notifye => {
            count = count + 1;
            reader = reader + (reader == "" ? "" : ",") + notifye.NotifyeID;
        });

        // Notifye/Develop Read - Enviar Lido
        if (reader) {
            this.profileService
                .central(TAction.acRead, reader, this.rootile.Profile.ProfileID)
                .subscribe(() => {
                    count = this.logado.Aboutme.NotifyeQtde - count;
                    if (count < 0) count = 0;

                    this.pushService.setBadge(count);
                    this.logadoService.notifyeQtds(count);
                });
        }
    }

    developLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.develop(TAction.acLoad, this.developID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.rootdev = data,
                erro => this.util.alertResult(erro, () => this.dismiss()));

    }

    developMenu(line) {

        let object = {etapa: 1, developID: line.DevelopID};
        this.navCtrl.push(DevelopMenuPage, object, {animation: 'md-transition'});

    }

    profilePage(profileID: number) {

        let object = {profileID: profileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    developJson(json) {

        return JSON.stringify(json, undefined, 2);

    }

    dismiss() {

        this.navCtrl.pop({animation: 'md-transition'});
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/develop-menu/develop-menu.ts